// Admin routes for P7-C (ANALYTICS-01…05, usage metering). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1:
//   …/reports                 → Sales (the default topic)
//   …/reports/ranking         ANALYTICS-05 store ranking (opt-in band)
//   …/reports/$topic          ANALYTICS-02/03/04 report topics
// The Today widgets (ANALYTICS-01) are mounted in pages/Today.tsx.
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../analytics/ReportsPage");
const RankingPage = lazyRouteComponent(load1, "RankingPage");
const ReportsPage = lazyRouteComponent(load1, "ReportsPage");
const TrafficPage = lazyRouteComponent(load1, "TrafficPage");

export function analyticsRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component });
  return [
    at("/$org/$store/reports", ReportsPage),
    at("/$org/$store/reports/ranking", RankingPage),
    at("/$org/$store/reports/$topic", ReportsPage),
    // Visitors and traffic (the section bar tab; was a dead link before 2026-10-22).
    at("/$org/$store/traffic", TrafficPage),
  ];
}
